import { render, staticRenderFns } from "./RoomSetting.vue?vue&type=template&id=309a0e7c&scoped=true&"
import script from "./RoomSetting.vue?vue&type=script&lang=js&"
export * from "./RoomSetting.vue?vue&type=script&lang=js&"
import style0 from "./RoomSetting.vue?vue&type=style&index=0&id=309a0e7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a0e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309a0e7c')) {
      api.createRecord('309a0e7c', component.options)
    } else {
      api.reload('309a0e7c', component.options)
    }
    module.hot.accept("./RoomSetting.vue?vue&type=template&id=309a0e7c&scoped=true&", function () {
      api.rerender('309a0e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/RoomSetting.vue"
export default component.exports